// See processOrgProxy() in ./index.js

const prefix = (url: any, prefix: any, encode: any) => {
	if (encode)
		url = encodeURIComponent(url);
	return prefix + url;
};

// @ts-expect-error TS(7006) FIXME: Parameter 'unprefixed_url' implicitly has an 'any'... Remove this comment to see the full error message
const unprefix = (unprefixed_url, encode) => {
	return encode
		? decodeURIComponent(unprefixed_url)
		: unprefixed_url;
};

// Simple array of hostnames, e.g. "muse.jhu.edu"
import all_research_hosts from "./research-hosts.json" assert {type:"json"};

/**
 * @param {Object} prefix_data
 * @param {string} prefix_data.prefix_url gets prepended to urls
 * @param {boolean} prefix_data.encode_url if true, the url is encoded when the prefix is prepended
 * @param {RegExp} prefix_data.unprefix_regex regex must have exactly one parentheses group to match the un-prefixed url
 * @param {RegExp} prefix_data.protocol_domain_path_regex regex must have 3 parentheses groups to match protocol, domain, and path
 * @return {array}
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'prefix_data' implicitly has an 'any' ty... Remove this comment to see the full error message
const build_simple_rules = prefix_data => ([
	{
		// e.g. from: https://muse-jhu-edu.ezproxy.babson.edu/article/44510
		//        to: http://ezproxy.babson.edu/login?url=https://muse.jhu.edu/article/44510
		regex:   prefix_data.protocol_domain_path_regex,
		// @ts-expect-error TS(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
		process: (url, protocol, domain, path) => ({
			url:   prefix(`${protocol}://${domain.replace(/-/g, ".")}/${path}`, prefix_data.prefix_url, prefix_data.encode_url),
			final: true
		}),
		toPublicUrl: false
	},
	{
		// e.g. from: http://www.jstor.org/stable/41441462
		//        to: prefixed (research db hostnames), or unprocessed (non-research-db hostnames)
		regex:   /^https?:\/\/([^\/]+).*$/,
		// @ts-expect-error TS(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
		process: (url, host) => {
			host = host.toLowerCase();

			return {
				url: all_research_hosts.find(h => host === h)
					? prefix(url, prefix_data.prefix_url, prefix_data.encode_url)
					: url,
				final: true
			};
		},
		toPublicUrl: false
	},
	{
		// from: prefixed url (e.g. http://ezproxy.babson.edu/login?url=https://muse.jhu.edu/article/44510)
		//   to: un-prefixed (public) url (e.g. https://muse.jhu.edu/article/44510)
		regex:   prefix_data.unprefix_regex,
		// @ts-expect-error TS(7006) FIXME: Parameter 'prefixed_url' implicitly has an 'any' t... Remove this comment to see the full error message
		process: (prefixed_url, url) => ({
			url:   unprefix(url, prefix_data.encode_url),
			final: true
		}),
		toPublicUrl: true
	}
]);

/**
 * A couple orgs use a proxy that has "wam" in the login/auth url,
 * so we'll call this the "wam" rules since I don't know what the
 * proxy is actually called.
 *
 * @param {Object} prefix_data
 * @param {string} prefix_data.prefix_url gets prepended to urls
 * @param {boolean} prefix_data.encode_url if true, the url is encoded when the prefix is prepended
 * @param {RegExp} prefix_data.unprefix_regex regex must have exactly one parentheses group to match the un-prefixed url
 * @param {RegExp} prefix_data.wam_unprefix_regex
 * @param {RegExp} prefix_data.wam_domain_path_regex
 * @return {array}
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'prefix_data' implicitly has an 'any' ty... Remove this comment to see the full error message
const build_wam_rules = prefix_data => ([
	{
		// http://0-science.sciencemag.org.library.4cd.edu/content/360/6392/943.full
		// to: prefixed url (hostname modified by proxy, e.g. "0-science.sciencemag.org.library.4cd.edu")
		regex:   prefix_data.wam_domain_path_regex,
		// @ts-expect-error TS(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
		process: url => ({
			url:   prefix(url, prefix_data.prefix_url, prefix_data.encode_url),
			final: true
		}),
		toPublicUrl: false
	},
	{
		// http://www.jstor.org/stable/41441462
		// to prefixed (research db hostnames), or unprocessed (non-research-db hostnames)
		regex:   /^https?:\/\/([^\/]+).*$/,
		// @ts-expect-error TS(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
		process: (url, host) => {
			host = host.toLowerCase();

			return {
				url: all_research_hosts.find(h => host === h)
					? prefix(url, prefix_data.prefix_url, prefix_data.encode_url)
					: url,
				final: true
			};
		},
		toPublicUrl: false
	},
	{
		// prefixed url
		// to: url (hostname modified by proxy, e.g. "0-science.sciencemag.org.library.4cd.edu")
		regex:   prefix_data.unprefix_regex,
		// @ts-expect-error TS(7006) FIXME: Parameter 'prefixed_url' implicitly has an 'any' t... Remove this comment to see the full error message
		process: (prefixed_url, url) => ({
			url:   unprefix(url, prefix_data.encode_url),
			final: false
		}),
		toPublicUrl: true
	},
	{
		// http://0-science.sciencemag.org.library.4cd.edu/content/360/6392/943.full
		// to: http://science.sciencemag.org/content/360/6392/943.full
		regex:   prefix_data.wam_unprefix_regex,
		// @ts-expect-error TS(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
		process: (url, protocol, domain, path) => ({
			url:   `${protocol}://${domain}/${path}`,
			final: true
		}),
		toPublicUrl: true
	}
]);

/**
 * @param {Object} prefix_data
 * @param {string} prefix_data.prefix_url gets prepended to urls
 * @param {boolean} prefix_data.encode_url if true, the url is encoded when the prefix is prepended
 * @param {RegExp} prefix_data.unprefix_regex regex must have exactly one parentheses group to match the un-prefixed url
 * @param {Object} port_host_mapping e.g. { 2214: ['http', 'www.jstor.org'], 2317: ['http', 'muse.jhu.edu'], ... }
 * @return {array}
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'prefix_data' implicitly has an 'any' ty... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const build_port_mapping_rules = (prefix_data, port_host_mapping) => ([
	{
		// http://proxy.oc.edu:2214/stable/41441462
		// to: http://www.jstor.org/stable/41441462
		regex:   /^https?:\/\/proxy\.oc\.edu:(\d+)\/(.+)$/,
		// @ts-expect-error TS(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
		process: (url, port, path) => {
			if (port_host_mapping[port] === undefined)
				return {url: url, final: true};

			return {
				url:   port_host_mapping[port][0] + "://" + port_host_mapping[port][1] + "/" + path,
				final: false // Do prefixing next
			};
		},
		toPublicUrl: false
	},
	{
		// http://www.jstor.org/stable/41441462
		// to prefixed
		regex:   /^https?:\/\/([^\/]+).*$/,
		// @ts-expect-error TS(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
		process: (url, host) => {
			host = host.toLowerCase();

			return {
				url: all_research_hosts.find(h => host === h)
					? prefix(url, prefix_data.prefix_url, prefix_data.encode_url)
					: url,
				final: true
			};
		},
		toPublicUrl: false
	},
	{
		// prefixed url
		// to: url (e.g. public proquest url)
		regex:   prefix_data.unprefix_regex,
		// @ts-expect-error TS(7006) FIXME: Parameter 'prefixed_url' implicitly has an 'any' t... Remove this comment to see the full error message
		process: (prefixed_url, url) => ({
			url:   unprefix(url, prefix_data.encode_url),
			final: true
		}),
		toPublicUrl: true
	}
]);

/**
 * Calculate proxy rules for the given account.
 *
 * Caches the results in the account object's computed property itself.
 * This way, if it ever changes, the cache is automatically cleared.
 *
 * @param {Object} account
 * @param {Object} [account.computed.proxy_config]
 * @param {string} [account.computed.proxy_config.type] "simple", "wam", or "port_mapping"
 * @param {array} [account.computed.proxy_config._rules] Cached results
 * @return {null|{regex: RegExp, process: (...string) => {url: string, final: boolean}, toPublicUrl: boolean}[]}
 */
// @ts-expect-error TS(2451) FIXME: Cannot redeclare block-scoped variable 'getRulesFo... Remove this comment to see the full error message
const getRulesForAccount = account => {
	if (account?.computed.proxy_config === undefined)
		return null;

	if (account.computed.proxy_config._rules !== undefined)
		return account.computed.proxy_config._rules;
	account.computed.proxy_config._rules = getRulesForConfig(account.computed.proxy_config);
	return account.computed.proxy_config._rules;
};

const getRulesForConfig = (config: {type: string; [key: string]: any}) => {
	config = JSON.parse(JSON.stringify(config)); // clone the object because we need to modify it a bit
	for (const k in config) {
		if (Object.prototype.hasOwnProperty.call(config, k) && k.endsWith("_prefix"))
			config[k] = new RegExp(config[k]);
	}

	let rules;
	switch (config.type) {
		case "simple":
			rules = build_simple_rules(config);
			break;
		case "wam":
			rules = build_wam_rules(config);
			break;
		case "port_mapping":
			// TODO: this doesn't work because it's trying to import a .json file asynchronously, but the function is not async
			// /**
			//  * The webpack comments are magic comments. See:
			//  * https://webpack.js.org/api/module-methods/#magic-comments
			//  * The webpackMode is based on the section about magic comments here:
			//  * https://medium.com/front-end-weekly/webpack-and-dynamic-imports-doing-it-right-72549ff49234
			//  * for making dynamic imports work with webpack for the extension
			//  * The webpackInclude comment makes it so that the regex for including
			//  * files in the build only looks for .json files, eliminating webpack
			//  * errors for trying to load .d.ts and .d files which are part of
			//  * this library's /build/src/url/utils output.
			// **/
			// import(
			// 	/* webpackMode: "eager" */
			// 	/* webpackInclude: /\.json$/ */
			// 	`./dynamic/${config.data_filename}.json`
			// ).then(result => {
			// 	rules = build_port_mapping_rules(config, result);
			// 	account.computed.proxy_config._rules = rules;
			// 	return account.computed.proxy_config._rules;
			// });
			break;
		default:
			console.warn("Unrecognized proxy config type", config);
	}

	return rules;
};

const getRulesForIntegration = () => {
	// @ts-ignore
	const config = window?.PowerNotes?.proxyRules;
	return config ? getRulesForConfig(config) : null;
};

export {getRulesForAccount, getRulesForIntegration};
